import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'
import axios from '@axios'

export default {
  namespaced: true,
  state: {
    schedules: [],
    schedulers: [],
    total: 0,
  },
  getters: {
    schedules: state => state.schedules,
    schedulers: state => state.schedulers,
    total: state => state.total,
  },
  mutations: {
    SET_SCHEDULES: (state, schedules) => { state.schedules = schedules },
    SET_SCHEDULERS: (state, schedulers) => { state.schedulers = schedulers },
    SET_TOTAL: (state, total) => { state.total = total },
  },

  actions: {

    async getSchedules({ commit }, params) {
      try {
        const response = await axios.post('uni/schedules', params)
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { records } = data.data
          const { total } = data.data
          commit('SET_SCHEDULES', records)
          commit('SET_TOTAL', total)
        }
      } catch (e) {
        handleCatch(e)
      }
    },

    async getSchedulers({ commit }, params) {
      try {
        const response = await axios.get('uni/schedules', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { records } = data.data
          const { total } = data.data
          commit('SET_SCHEDULERS', records)
          commit('SET_TOTAL', total)
        }
      } catch (e) {
        handleCatch(e)
      }
    },

    async getSchedulersV3({ commit }, params) {
      try {
        const response = await axios.get('uni/schedules/getSchedulesV3', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { records } = data.data
          const { total } = data.data
          commit('SET_SCHEDULERS', records)
          commit('SET_TOTAL', total)
        }
      } catch (e) {
        handleCatch(e)
      }
    },

    async getSchedulersByDayAndCreditClass({ commit }, params) {
      try {
        const response = await axios.get('uni/schedules/getSchedulesByDayAndCreditClass', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_SCHEDULERS', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },

    async createSchedule({ commit }, dataObj) {
      try {
        const response = await axios.post('uni/schedules/createSchedule', dataObj)
        const { data } = response
        return data
      } catch (e) {
        handleCatch(e)
      }
    },

    async updateSchedule({ commit }, dataObj) {
      try {
        const response = await axios.put('uni/schedules', dataObj)
        const { data } = response
        return data
      } catch (e) {
        handleCatch(e)
      }
    },

    async deleteSchedule({ commit }, id) {
      try {
        const response = await axios.delete(`uni/schedules/${id}`)
        const { data } = response
        return data.code === ApiCode.SUCCESS
      } catch (e) {
        handleCatch(e)
      }
    },
    async deleteScheduleByCreditClassAndRoomAndTeacher({ commit }, item) {
      try {
        const response = await axios.delete(`uni/schedules/${item.creditClassId}/${item.roomId}/${item.teacherId}/${item.yearWeekId}/${item.checkRemoveAll}`)
        const { data } = response
        return data.code === ApiCode.SUCCESS
      } catch (e) {
        handleCatch(e)
      }
    },
    async exportScheduler({ commit }, params) {
      try {
        const responseStudentInfo = await axios({
          method: 'get',
          url: 'uni/reports/reportScheduler',
          responseType: 'blob',
          params,
        })
        return responseStudentInfo.data
      } catch (e) {
        handleCatch(e)
      }
    },
  },
}
